import { useContext } from "react";
import { StepperContext, useLoanApplication } from "../../../contexts";
import { LoanApplicationStage } from "../../../hooks/api/types";
import SumSubKyc from "./SumSubKyc";
import { useLoanProductConfigFlags } from "../../../hooks/useLoanProductConfigFlags";

const OwnersKycForm = () => {
  const { nextStep, previousStep } = useContext(StepperContext);
  const {
    state: { loanType },
    actions: { update },
  } = useLoanApplication();

  const { shouldHideFinancialInformation } =
    useLoanProductConfigFlags(loanType);

  const handleNext = async () => {
    try {
      await update({
        stage: shouldHideFinancialInformation
          ? LoanApplicationStage.DOCUMENTS_UPLOAD
          : LoanApplicationStage.FINANCIAL_INFORMATION,
      });
      nextStep();
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrevious = async () => {
    try {
      await update({
        stage: LoanApplicationStage.SHAREHOLDER_INFORMATION,
      });
      previousStep();
    } catch (err) {
      console.log(err);
    }
  };

  return <SumSubKyc onSubmit={handleNext} onPrev={handlePrevious} />;
};

export default OwnersKycForm;
